import { ArrowRightOutlined } from '@ant-design/icons';
import { type TipoDomandaDTO } from '@framework/api-client/api/inquiries/schemas/tipoDomandaDTO.ts';
import { LinkButton } from '@framework/ui/components/button/LinkButton.tsx';
import { generatePath } from '@framework/ui/core/router/TypedRoute.tsx';
import { useTranslation } from 'react-i18next';

export interface IInquiryLinkButtonProps {
  inquiry: TipoDomandaDTO;
}

/**
 * Pulsante "vai alla domanda" dell'item "tipo domanda" della lista delle domande.
 */
export function InquiryLinkButton(props: IInquiryLinkButtonProps) {
  const { inquiry } = props;

  const { t } = useTranslation();

  const buttonText = t(
    'domande.lista.elemento.pulsante.vai-alla-domanda',
    'Vai alla Domanda',
  );

  const buttonAriaLabel = buttonText + ' ' + inquiry.titolo;

  return (
    <LinkButton
      type="primary"
      size="large"
      aria-label={buttonAriaLabel}
      to={generatePath('/domande/:id', { id: inquiry.id! })}
    >
      {buttonText}
      <ArrowRightOutlined aria-hidden />
    </LinkButton>
  );
}
